var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agency-hero" },
    [
      _vm._t("breadcrumb"),
      _vm._v(" "),
      _c("agency-lead-modal"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container agency mt-5 mb-4",
          attrs: { id: "agencymap" }
        },
        [
          _c(
            "agency-card",
            { attrs: { "include-modal": true, agency: _vm.agency } },
            [
              _c(
                "template",
                { slot: "business_name" },
                [_vm._t("business-name")],
                2
              ),
              _vm._v(" "),
              _c("template", { slot: "district" }, [_vm._t("district")], 2),
              _vm._v(" "),
              _c("template", { slot: "address" }, [_vm._t("address")], 2),
              _vm._v(" "),
              _c(
                "template",
                { slot: "email" },
                [
                  _c(
                    "modal-opener",
                    { attrs: { name: "agency-lead", data: _vm.agency.id } },
                    [
                      _c("a", { staticClass: "email" }, [
                        _c("img", {
                          attrs: { src: "/img/icons/mail-agency.svg" }
                        }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.agency.email) +
                            "\n                    "
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("template", { slot: "phone" }, [
                _c(
                  "a",
                  {
                    staticClass: "phone",
                    attrs: { href: "tel:" + _vm.agency.phone }
                  },
                  [
                    _c("masked-image", {
                      staticStyle: { width: "1rem" },
                      attrs: {
                        src: "/img/icons/phone-agency.svg",
                        alt: _vm.agency.phone
                      }
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.phoneToShow) +
                        "\n                "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("template", { slot: "links" }, [
                _c(
                  "div",
                  { staticClass: "links-container" },
                  [_vm._t("links")],
                  2
                )
              ]),
              _vm._v(" "),
              _vm.agency.team
                ? _c(
                    "template",
                    { slot: "team" },
                    [
                      _c("agency-team-carousel", {
                        attrs: { team: _vm.agency.team }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.isActive
            ? _c("agency-map", {
                attrs: {
                  latitude: _vm.agency.latitude,
                  longitude: _vm.agency.longitude,
                  network: _vm.agency.network,
                  sector: _vm.agency.sector,
                  "tecnomaps-endpoint": _vm.tecnomapEndpoint,
                  marker: _vm.marker
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.description
            ? _c(
                "div",
                { staticClass: "agency-card" },
                [_vm._t("description")],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }